export default __webpack_public_path__ + "static/N0294-c8d55323ce7a02396311670c80810f2c.png";